import React from 'react';
import apiClient, { getAccessToken } from '../../apiClient';
import './PaymentMethod.scss';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline"; 
import MaterialTable from '../../Components/DataTable/DataTable';
import { CSVLink } from "react-csv";
import { withRouter } from 'react-router-dom';
import AddBoxIcon from "@material-ui/icons/AddBox"; 
import Dialog  from "@material-ui/core/Dialog"; 
import DialogActions from "@material-ui/core/DialogActions"; 
import DialogContent from "@material-ui/core/DialogContent"; 
import DialogContentText from "@material-ui/core/DialogContentText"; 
import DialogTitle from "@material-ui/core/DialogTitle";
import { Button, Table,
	TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
  import { makeStyles } from "@material-ui/core/styles"; 

import withFlashNotification from '../Notification/withFlashNotification';
import { notifyApiError } from '../Notification/notificationHelpers';
import { validatePaymentMethodRows } from '../formValidation';
 class PaymentMethod extends React.Component {

  handleLinkEditClick = (item,action) => {
    this.setShowEdit(true);
    this.setState({currentPaymentMethodId:item.PaymentMethodId});
    this.setState({currentName:item.Name});
    this.setState({currentPercent:item.Percent});
  };

  handleEditName = () => {
    const validationError = validatePaymentMethodRows([{
      name: this.state.currentName,
      percent: this.state.currentPercent,
    }]);
    if (validationError) {
      this.setState({ errorMessage: validationError, successMessage: null });
      this.props.showFlashNotification(validationError, 'error');
      return;
    }
   let user = JSON.parse(sessionStorage.getItem('user'));
            let accessToken = user.accessToken;
          apiClient.post(`/api/post/paymentMethodUpdate`, { name:this.state.currentName,percent:this.state.currentPercent,paymentMethodId:this.state.currentPaymentMethodId }, { headers: {"Authorization" : `Bearer ${accessToken}`} })
            .then(res => {
            
              this.setState({ successMessage: 'Successfully saved!' });
        
              setTimeout(() => {
                this.setState({ successMessage: null });
                sessionStorage.setItem('ItemTabIndex', JSON.stringify(0));
                  const { history } = this.props;
                  history.push('/vendor-details');
                    setTimeout(() => {
                      history.push('/payment-method');
                    }, 1); 
               
              }, 3000);
              this.setShowEdit(false);
            })
            .catch(error => {
              const message =
                error && error.response && error.response.data && error.response.data.error
                  ? error.response.data.error
                  : 'Unable to save payment method.';
              this.setState({ errorMessage: message, successMessage: null });
              this.props.showFlashNotification(message, 'error');
              setTimeout(() => this.setState({ errorMessage: null }), 8000);
            });
        }

  setShowEdit= (state) => {
    
    this.setState({showEdit:state});
   
  };

 

  useStyles = makeStyles({ 
    root: { 
      "& > *": { 
        borderBottom: "unset", 
      }, 
    }, 
    
    snackbar: { 
      bottom: "104px", 
    }, 
    table: {
      maxWidth: '100%', // Set to '100%' to make the table responsive
      },
      tableHeader: {
      backgroundColor: '#f2f2f2',
      fontWeight: 'bold',
      },
      tableRow: {
      '&:hover': {
        backgroundColor: '#e0e0e0',
      },
      },
      tableCell: {
      borderBottom: '1px solid #dddddd',
      width:"150px !important",
      },
      rowDiv: {
      width:"1000px !important",
      },
      dialogCustom:{
      width:"800px !important",
      height:"600px !important",
      },
      divRight:{
      float:"right"
      }
      ,
      divLeft:{
      float:"left"
      }
  }); 

   
    state = {
      barcodeSrc:'',
        Results: [],
        selectedItem:null,
        showBarCode:false,
        showEdit:false,
        currentPaymentMethodId:0,
        currentName:"",
        currentPercent:0,
        fullWidth:true,
        noOfPrint:null,
        maxWidth:'sm',
        columns: [
          
          { title: '', field: 'PaymentMethodId' ,
            render: rowData => (
              <a
                href="javascript:void(0)"
                onClick={() => this.handleLinkEditClick(rowData,'edit')}
              >
                {'Edit'}
              </a>
            )
          
          },
          
          { title: "Payment Method Name", field: "Name" },
            { title: 'Percentage %', field: 'Percent' },
        ],
        headers: [
          { label: "Payment Method Name", key: "Name" },
          { label: "Percentage %", key: "Percent" }
        ],
        vendorList: [],
        categoryList: [],
        formData: {
            name: '',
            percent: 0
        },
        submitted: false,
        successMessage:null,
        errorMessage:null,
        index:0,
        IsAdded:false,
        rows:[],
        edit:false,
        disable:false,
       showConfirm:false,
       rowIndex:0
    }

  

    componentDidMount() {
     
     
let ItemTabIndex = JSON.parse(sessionStorage.getItem('ItemTabIndex'));
if(ItemTabIndex == '1')
{
   this.setState({
    index: 1,
   });

}

      sessionStorage.setItem('TranSearch', null);
        let user = JSON.parse(sessionStorage.getItem('user'));
        let accessToken = getAccessToken();
  
      
          apiClient.get(`/api/get/paymentmethod`, { headers: {"Authorization" : `Bearer ${accessToken}`} })
          .then(res => {
            const Results = res.data;
            this.setState({ Results });
          })
          .catch(error => notifyApiError(
            this.props.showFlashNotification,
            error,
            'Unable to load payment methods.'
          ));
  
          
         if(user.permissions.filter(x=>x.PermissionName == 'Inventory' && x.PermissionAllowed == 1).length == 0)
         {
            const { history } = this.props;
            history.push('/home');
         }
      }

      handleNo = () => { 
        this.setState({showConfirm:false}); 
      }; 

    handleChange = (event) => {
        const { formData } = this.state;
        formData[event.target.name] = event.target.value;
        this.setState({ formData });
    }

    handleInputChangePrintLabel = (e) => { 
      this.setState({noOfPrint:e.target.value}); 
    }; 

    handleInputChangeName = (e) => { 
      this.setState({currentName:e.target.value}); 
    }; 

     handleInputChangePercent = (e) => { 
      this.setState({currentPercent:e.target.value}); 
    }; 

    

    handleSubmit = () => {
      const validationError = validatePaymentMethodRows(this.state.rows);
      if (!validationError)
        {

          let user = JSON.parse(sessionStorage.getItem('user'));
          let accessToken = user.accessToken;
                    apiClient.post(`/api/post/paymentmethods`,  this.state.rows , { headers: {"Authorization" : `Bearer ${accessToken}`} })
                  .then(res => {
                      const result = res.data;
                      this.setState({ result });
                    this.setState({ successMessage: 'Successfully saved!' });
                    setTimeout(() => {
                      this.setState({ successMessage: null });
                      
                        const { history } = this.props;
                        history.push('/vendor-details');
                          setTimeout(() => {
                            history.push('/payment-method');
                          }, 1); 
                      
                    }, 3000);
                  })
                  .catch(error => notifyApiError(
                    this.props.showFlashNotification,
                    error,
                    'Unable to save payment methods.'
                  ));
            }else{
              this.setState({ errorMessage: validationError, loading: false });
              this.props.showFlashNotification(validationError, 'error');
              setTimeout(() => this.setState({errorMessage:null}), 10000);
            }
    }


    handleRemoveClick = (i) => { 
      const list = [...this.state.rows]; 
      this.setState({rows:null});
      let listNew = list.filter(x=>x.id !== (this.state.rowIndex)); 
      this.setState({rows:listNew}); 
      this.setState({showConfirm:false}); 
      this.setState({addItem:false});
    }; 

    handleConfirm = (index) => {
      this.setState({showConfirm:true});
      this.setState({rowIndex:index});
    }; 

    handleCategoryChange = (e, index) => { 
      const list = [...this.state.rows];
      list[index]['categoryId'] = e.target.value;
      this.setState({rows:list}); 
			
    };

    handleInputChange = (e, index,type='') => { 
      this.setState({disable:false}); 
        const { name, value } = e.target; 
        const list = [...this.state.rows]; 
        list[index][name] = value;
        this.setState({rows:list}); 
    }; 

    setBarCode = (action) => {
      
      this.setState({ showBarCode: action });
     
    };

    setEdit = (action) => {
      
      this.setState({ showEdit: action });
     
    };


    handleAdd = () => { 

      if(this.state.rows.length == 0)
      {
        this.setState({IsAdded:true});
        this.setState({rows:[ 
          ...this.state.rows,
          {
            id: '',paymentmethodId:0,name:'', percent: 0
          }, 
        ]}); 
        this.setState({edit:true}); 

      }
      else{

         if( this.state.rows[this.state.rows.length - 1].name != '' && this.state.rows[this.state.rows.length - 1].percent != undefined)
        {
          this.setState({IsAdded:true});
        this.setState({rows:[ 
          ...this.state.rows, 
          { 
            id: this.state.rows.length + 1,  
            itemid: '',paymentmethodId:0,name:'', percent: 0
          }, 
        ]}); 
        this.setState({edit:true}); 
    }else{
    
          var errorMsg = 'In last item added, Following fields need to be checked ';
          
          
           if(this.state.rows[this.state.rows.length - 1].name == '' )
              {
                errorMsg += 'Payment Method Name. \r\n';
              }

              if(this.state.rows[this.state.rows.length - 1].percent == undefined )
              {
                errorMsg += 'Percentage %. \r\n';
              }


          errorMsg += '. Pls fill out the required fields.';
          
          setTimeout(() => {
            this.setState({errorMessage:errorMsg});
          }, 1000);
           
          setTimeout(() => {
            this.setState({errorMessage:null});
           
            this.setState({loading:false});   
        }, 10000);    
        }
      }     
    }; 

    handleChildClick = () => {
      this.props.onSendValue();
      };

      a11yProps(index) {
        return {
          id: `scrollable-auto-tab-${index}`,
          'aria-controls': `scrollable-auto-tabpanel-${index}`,
        };
      }
      onTabClicked = (event, newValue) => {
        this.setState({ index: newValue });
    }

   

    render() {

        const { submitted } = this.state;
        return (
      <div>

                   
        <div className="TargetPrice">
       
                  <div>
                    <h2>Payment Method</h2>
                                    <br />
                  </div> 
                
       
        <div style={{ display: "flex", justifyContent: "space-between", marginTop:"20px" }}> 
                <div> 
                      <div className="alignDiv">
                        <Button onClick={this.handleAdd}> 
                        <AddBoxIcon onClick={this.handleAdd} /> 
                        ADD 
                        </Button> 
                        </div>
                </div> 

                </div> 
                <div style={{  marginTop:"10px" }}>
                    <Table  className="" 
                        size="small"
                        aria-label="a dense table"
                        > 
                            <TableHead> 
                                  <TableRow className="" > 
                                        <TableCell className=""  align="center">Payment Name</TableCell> 
                                        <TableCell className=""  align="center">Percentage %</TableCell> 
                                        <TableCell className=""  align="center"></TableCell> 
                                  </TableRow> 
                            </TableHead> 
                            <TableBody> 
                                            {this.state.rows.map((row, i) => {   
                                            return ( 
                                                    <TableRow className=""  > 
                                                    <TableCell padding="none" style={{ textAlign: 'left' }}> 
                                                        <input 
                                                          type="text"
                                                          value={row.name} 
                                                          name="name"
                                                          onChange={(e) => this.handleInputChange(e, i)} 
                                                        /> 
                                                    </TableCell> 
                                                    <TableCell padding="none" style={{ textAlign: 'left' }}> 
                                                        <input 
                                                          type="number"
                                                          value={row.percent} 
                                                          name="percent"
                                                          onChange={(e) => this.handleInputChange(e, i)} 
                                                        /> 
                                                    </TableCell> 
                                                  
                                                  <TableCell  className="" 
                                                        component="th"
                                                        scope="row"
                                                        align="center"
                                                        >
                                                          <Button className="mr10" onClick={(e) =>this.handleConfirm(row.id)}> 
                                                              <DeleteOutlineIcon /> 
                                                            </Button> 
                                                    </TableCell> 
                                                
                                                          {this.state.showConfirm && ( 
                                                              <div> 
                                                                <Dialog 
                                                                open={this.state.showConfirm} 
                                                                onClose={this.handleNo} 
                                                                aria-labelledby="alert-dialog-title"
                                                                aria-describedby="alert-dialog-description"
                                                                > 
                                                                <DialogTitle id="alert-dialog-title"> 
                                                                  {"Confirm Delete"} 
                                                                </DialogTitle> 
                                                                <DialogContent> 
                                                                  <DialogContentText id="alert-dialog-description"> 
                                                                  Are you sure to delete
                                                                  </DialogContentText> 
                                                                </DialogContent> 
                                                                <DialogActions> 
                                                                  <Button 
                                                                  onClick={() => this.handleRemoveClick()}
                                                                  color="primary"
                                                                  autoFocus 
                                                                  > 
                                                                  Yes 
                                                                  </Button> 
                                                                  <Button 
                                                                  onClick={this.handleNo} 
                                                                  color="primary"
                                                                  autoFocus 
                                                                  > 
                                                                  No 
                                                                  </Button> 
                                                                </DialogActions> 
                                                                </Dialog> 
                                                              </div> 
                                                            )} 
                                                      </TableRow> 
                                              
                                                ); 
                                            })} 
                            </TableBody> 
                    </Table> 
                    <br /><br /><br />
                    <Button
                        color="primary"
                        variant="contained"
                        onClick={this.handleSubmit}
                      
                        disabled={submitted}
                    >
                        {
                            (submitted && 'Your form is submitted!')
                            || (!submitted && 'Submit')
                        }
                    </Button>

                    {this.state.successMessage && (
              <div
                style={{
                  backgroundColor: '#28a745',
                  color: '#fff',
                  padding: '10px',
                  marginTop: '10px',
                }}
              >
                {this.state.successMessage}
              </div>
            )}

    {this.state.errorMessage && (
            <div style={{ backgroundColor: '#FF7F7F', color: '#fff', padding: '10px', marginTop: '10px' }}>
              {this.state.errorMessage}
            </div>
          )}
                </div>
                
                
              
   

    <div style={{ maxWidth: '100%', paddingTop: '50px' }}>
    <div style={{textAlign:'right', paddingBottom: '3px'}}>
    <CSVLink data={this.state.Results} headers={this.state.headers}>
    Export to Excel
    </CSVLink>

    </div>
    <MaterialTable
    columns={this.state.columns}
    data={this.state.Results}
    title="Payment Methods"
    />


    </div>

  
              
            </div>
        
                    
   {this.state.showEdit && ( 
					<div> 
						<Dialog  
						  fullWidth={this.state.fullWidth}
						  maxWidth={this.state.maxEditWidth}
						open={this.state.showEdit} 
						onClose={() => this.setEdit(false)} 
						> 
            <DialogTitle id="alert-dialog-title"> 
						<div style={{float:"left"}}><h4>Edit Payment Method</h4></div>
						<div style={{float:"right"}}>
						<IconButton
								aria-label="close"
								onClick={() => this.setShowEdit(false)}
								sx={{
									position: "fixed",
									right: 8,
									top: 5,
									color: (theme) => theme.palette.grey[500]
								}}
								>
								<CloseIcon />
								</IconButton>
						</div>
							
							
						</DialogTitle> 
					
						<DialogContent id="alert-dialog-description"> 
							<DialogContentText > 
                <div className="row mt-5" >
                    
                    <div class="row mt-5">
                    <div class="col-md-5" style={{float:"left",marginRight:"50px"}}>
                        <label>Payment Method Name</label>
                    </div>
                    <div class="col-md-7">
                    <input style={{width:"250px"}}
                            type="text"
                            value={this.state.currentName} 
                            name="noOfPrint"
                            onChange={(e) => this.handleInputChangeName(e)} 
                          /> 
                    </div>
                    </div>
                    <br/>
                    <div class="row mt-5">
                    <div class="col-md-5" style={{float:"left",marginRight:"120px"}}>
                        <label>Percentage %</label>
                    </div>
                    <div class="col-md-7">
                    <input style={{width:"250px"}}
                            type="number"
                            value={this.state.currentPercent} 
                            name="noOfPrint"
                            onChange={(e) => this.handleInputChangePercent(e)} 
                          /> 
                    </div>
                    </div>
                    <br/>
                 
                    <br/>
                    <div class="row mt-5"  style={{textAlign:"center"}}>
                        <div class="col-md-6 mr-1" style={{textAlign:"center",float:"left",marginRight:"2px"}}>
                            <Button className="mr10"  color="primary"
                                            variant="contained" onClick={this.handleEditName} > 
                                                                               Save
                                                                                </Button> 
                        </div>
                        <div class="col-md-6" style={{textAlign:"center",float:"left"}}>
                            <Button className="mr10"  color="primary"
                                            variant="contained" onClick={() => this.setShowEdit(false)} > 
                                                                                Close
                                                                                </Button> 
                        </div>
                    </div>
                </div>
							</DialogContentText> 
						</DialogContent> 
						<DialogActions> 
						</DialogActions> 
						</Dialog> 
            
					</div> 
					)} 
  


</div>


       
        );
    }
}
export default withRouter(withFlashNotification(PaymentMethod));
